import { render, staticRenderFns } from "./orders-form-container.vue?vue&type=template&id=03269e27&scoped=true&"
import script from "./orders-form-container.vue?vue&type=script&lang=js&"
export * from "./orders-form-container.vue?vue&type=script&lang=js&"
import style0 from "./orders-form-container.vue?vue&type=style&index=0&id=03269e27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03269e27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03269e27')) {
      api.createRecord('03269e27', component.options)
    } else {
      api.reload('03269e27', component.options)
    }
    module.hot.accept("./orders-form-container.vue?vue&type=template&id=03269e27&scoped=true&", function () {
      api.rerender('03269e27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/orders-form-container.vue"
export default component.exports